module.exports = __webpack_public_path__ + "dj.556d36ea.svg";